var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3700_11152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69568 8.24867C10.866 7.63601 11.666 6.41234 11.666 4.99967C11.666 2.97467 10.0243 1.33301 7.99935 1.33301C5.97435 1.33301 4.33268 2.97467 4.33268 4.99967C4.33268 6.41234 5.13268 7.63601 6.30302 8.24867C3.62935 9.02967 1.66602 11.6027 1.66602 14.6663H14.3327C14.3327 11.6027 12.3693 9.02967 9.69568 8.24867ZM4.99935 4.99967C4.99935 3.34534 6.34502 1.99967 7.99935 1.99967C9.65368 1.99967 10.9993 3.34534 10.9993 4.99967C10.9993 6.65401 9.65368 7.99967 7.99935 7.99967C6.34502 7.99967 4.99935 6.65401 4.99935 4.99967ZM7.99935 8.66634C10.911 8.66634 13.317 11.004 13.6313 13.9997H2.36735C2.68168 11.004 5.08768 8.66634 7.99935 8.66634Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3700_11152)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 12C8.75 10.205 10.205 8.75 12 8.75C13.795 8.75 15.25 10.205 15.25 12C15.25 13.795 13.795 15.25 12 15.25C10.205 15.25 8.75 13.795 8.75 12ZM12.5427 10.6943C12.246 10.4353 11.754 10.4353 11.4577 10.6943C11.4078 10.738 11.3426 10.7601 11.2764 10.7557C11.2102 10.7513 11.1485 10.7207 11.1048 10.6708C11.0612 10.6209 11.0391 10.5557 11.0435 10.4895C11.0479 10.4234 11.0784 10.3617 11.1283 10.318C11.613 9.894 12.387 9.894 12.8717 10.318C13.376 10.7593 13.376 11.4907 12.8717 11.932C12.7873 12.0055 12.6935 12.0674 12.5927 12.116C12.3673 12.2253 12.25 12.374 12.25 12.5V12.75C12.25 12.8163 12.2237 12.8799 12.1768 12.9268C12.1299 12.9737 12.0663 13 12 13C11.9337 13 11.8701 12.9737 11.8232 12.9268C11.7763 12.8799 11.75 12.8163 11.75 12.75V12.5C11.75 12.0737 12.1033 11.7977 12.375 11.666C12.4355 11.6368 12.4919 11.5997 12.5427 11.5557C12.8193 11.3133 12.8193 10.9367 12.5427 10.6943ZM12 14C12.0663 14 12.1299 13.9737 12.1768 13.9268C12.2237 13.8799 12.25 13.8163 12.25 13.75C12.25 13.6837 12.2237 13.6201 12.1768 13.5732C12.1299 13.5263 12.0663 13.5 12 13.5C11.9337 13.5 11.8701 13.5263 11.8232 13.5732C11.7763 13.6201 11.75 13.6837 11.75 13.75C11.75 13.8163 11.7763 13.8799 11.8232 13.9268C11.8701 13.9737 11.9337 14 12 14Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3700_11152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3700_11152"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonQuestionMark);
export default __webpack_public_path__ + "static/media/personQuestionMark.30c311cbfc3fb72291071d4ad7959704.svg";
export { ForwardRef as ReactComponent };